import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType  } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {signupFormEdit_template} from "../components/templates/signupFormEdit_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class signup_form_edit extends vnModule_knockoutJS{
    protected signupFormEdit : signupFormEdit_template
    protected XHRHdl: XMLHttpRequestHandler;
    protected _isLeavePageWarningNeeded: boolean = true;

    buildContent(): Array<Element> {
        this.signupFormEdit = new signupFormEdit_template('signupFormEdit', this.viewModel, this)
        return [this.signupFormEdit.build()]
    }

    protected getModuleName(): string {
        return "signup_form_edit";
    }

    public fillPage() {
        this.getSignupFormDataForEdit()
    }

    private getSignupFormDataForEdit() {
        this.loadingIn(this.signupFormEdit.builtTemplate);

        let url : string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/signupForm/get/edit/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetSignupFormDataForEdit;
        this.XHRHdl.execute();
    }

    private onGetSignupFormDataForEdit(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                let signupForm = responseParsed.data
                let availableFields = responseParsed.availableFields
                let availableMailingLists = responseParsed.availableMailingLists
                obj.setSignupFormData(signupForm, availableFields, availableMailingLists);
            });
            obj.loadingOut(obj.signupFormEdit.builtTemplate);
        }
    }

    protected setSignupFormData(signupForm, availableFields, availableMailingLists) {
        this.signupFormEdit.generateDropzone(this.getVnAppZone().app.params.idBrand)
        this.signupFormEdit.setId(signupForm.id)
        this.signupFormEdit.setIdForm(signupForm.idForm)
        this.signupFormEdit.setLabel(signupForm.label)
        this.signupFormEdit.setButtonText(signupForm.buttonText)
        this.signupFormEdit.setFields(signupForm.fields)
        this.signupFormEdit.setMailingLists(signupForm.mailingLists)
        this.signupFormEdit.setAvailableFields(availableFields)
        this.signupFormEdit.setAvailableMailingLists(availableMailingLists)
    }

    public cancelForm() {
        this.onClickCancelEdit();
    }

    public onClickCancelEdit(){
        let brandId = this.getVnAppZone().app.params.idBrand
        page.redirect("/brand/" + brandId + "/newsletter/signup-forms/")
    }

    protected save() {
        this.loadingIn(this.signupFormEdit.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url: string = '/api/brand/' + idBrand + "/signupForm/save/";
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.viewModel));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    page.redirect('/brand/' + idBrand + "/newsletter/signup-forms/");

                    if (req.request.status === 200) {
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Signup Form saved !");
                        //obj.getVnAppZone().showNotificationToModule();
                    }
                });
                obj.loadingOut(obj.signupFormEdit.builtTemplate);
            }
        });
        XHRHdl.execute();
    }
}


// WEBPACK FOOTER //
// ./js/modules/signup_form_edit.ts